"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validImage = void 0;

const validImage = file => file.type.includes('image') && file.size < 5000 * 1000;

exports.validImage = validImage;